import classnames from "classnames"
import React from "react"

export default function NavbarTopicsToggle({
  id,
  className,
  active,
  onClick,
}) {
  return (
    <button
      id={id}
      className={classnames("btn btn-navbar-topics", className, { active })}
      title={pgettext("navbar", "Browse topics")}
      type="button"
      onClick={onClick}
    >
      <span className="topics-text">
        {pgettext("navbar", "Topics")}
      </span>
      <span className="material-icon dropdown-arrow">
        {active ? "keyboard_arrow_up" : "keyboard_arrow_down"}
      </span>
    </button>
  )
}